import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'

import { Button } from '../../components/ui/button'
import { customAgentConfigHref } from '../../lib/component-links'
import { splitRunError } from './run-timing'

interface Props {
  error?: string | null
  invocationCount: number
  configId?: string | null
  onRerun?: () => void
  rerunning?: boolean
}

export function RunFailure({
  error,
  invocationCount,
  configId,
  onRerun,
  rerunning = false
}: Props) {
  const heading = invocationCount > 0 ? `Run failed after ${invocationCount} steps` : 'Run failed'

  return (
    <div className="flex gap-3 rounded-lg border border-st-down/40 bg-st-down-bg/40 px-4 py-3.5">
      <AlertTriangle className="size-5 shrink-0 text-st-down" aria-hidden />
      <div className="min-w-0">
        <div className="text-14 font-semibold text-ink">{heading}</div>
        {error ? (
          <p className="m-0 mt-1 text-13 leading-relaxed text-ink-2">
            {splitRunError(error).map((part, i) =>
              part.mono ? (
                <span key={i} className="font-mono">
                  {part.text}
                </span>
              ) : (
                <span key={i}>{part.text}</span>
              )
            )}
          </p>
        ) : null}
        {configId || onRerun ? (
          <div className="mt-2.5 flex gap-2">
            {onRerun ? (
              <Button variant="outline" size="sm" onClick={onRerun} disabled={rerunning}>
                Re-run
              </Button>
            ) : null}
            {configId && (
              <Button variant="outline" size="sm" asChild>
                <Link to={customAgentConfigHref(configId)}>Open config</Link>
              </Button>
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}
